/**
 * Manage global libraries like jQuery or THREE from the package.json file
 */

// Import custom modules

import 'bootstrap';

import App from './modules/app.js';
import Carousel from './modules/carousel.js';
//import ReadMore from 'read-smore';
import LoadMorePosts from './modules/load-more-posts.js';
import Maps from './modules/maps.js';
import Menu from './modules/menu.js';
import Filter from './modules/filter.js';
import Tabs from './modules/tabs.js';
import Ticker from './modules/ticker.js';
import LiveChat from './modules/livechat.js';
import AOS from 'aos';
import MicroModal from 'micromodal';

const app = new App();
const menu = new Menu();
const carousel = new Carousel();
const loadmoreposts = new LoadMorePosts();
const maps = new Maps();
const filter = new Filter();
const tabs = new Tabs();
const ticker = new Ticker();
const livechat = new LiveChat();

// TODO, translate and import import ReadMore from 'read-smore'
const ReadMore = (() => {
	let s;

	return {

		settings() {
			return {
				content: document.querySelectorAll('.js-read-more'),
				originalContentArr: [],
				truncatedContentArr: [],
				moreLink: "Läs mer",
				lessLink: "Visa mindre",
			}
		},

		init() {
			s = this.settings();
			this.bindEvents();
		},

		bindEvents() {
			ReadMore.truncateText();
		},
		countWords(str) {
			return str.split(/\s+/).length;
		},

		ellipseContent(str, wordsNum) {
			return str.split(/\s+/).slice(0, wordsNum).join(' ') + '...';
		},
		truncateText() {

			for (let i = 0; i < s.content.length; i++) {
				const originalContent = s.content[i].innerHTML;
				const numberOfWords = s.content[i].dataset.rmWords;
				const truncateContent = ReadMore.ellipseContent(originalContent, numberOfWords);
				const originalContentWords = ReadMore.countWords(originalContent);

				s.originalContentArr.push(originalContent);
				s.truncatedContentArr.push(truncateContent);

				if (numberOfWords < originalContentWords) {
					s.content[i].innerHTML = s.truncatedContentArr[i];
					let self = i;
					ReadMore.createLink(self)
				}
			}
			ReadMore.handleClick(s.content);
		},
		createLink(index) {
			const linkWrap = document.createElement('span');

			linkWrap.className = 'read-more__link-wrap';

			linkWrap.innerHTML = `<a id="read-more_${index}" class="read-more__link" style="cursor:pointer;">${s.moreLink}</a>`;
			s.content[index].parentNode.insertBefore(linkWrap, s.content[index].nextSibling);

		},
		handleClick(el) {
			const readMoreLink = document.querySelectorAll('.read-more__link');

			for (let j = 0, l = readMoreLink.length; j < l; j++) {

				readMoreLink[j].addEventListener('click', function () {

					const moreLinkID = this.getAttribute('id');
					let index = moreLinkID.split('_')[1];

					el[index].classList.toggle('is-expanded');

					if (this.dataset.clicked !== 'true') {
						el[index].innerHTML = s.originalContentArr[index];
						this.innerHTML = s.lessLink;
						this.dataset.clicked = true;
					} else {
						el[index].innerHTML = s.truncatedContentArr[index];
						this.innerHTML = s.moreLink;
						this.dataset.clicked = false;
					}
				});
			}
		},
		openAll() {
			const instances = document.querySelectorAll('.read-more__link');
			for (let i = 0; i < instances.length; i++) {
				content[i].innerHTML = s.truncatedContentArr[i];
				instances[i].innerHTML = s.moreLink;
			}
		}
	}
})();

export default ReadMore;


/**
 * Init libs
 */

$(document).ready(function () {

	// init aos
	AOS.init({
		delay: 0,
		offset: -200,
		once: true
	});

	// lineup
	MicroModal.init({
		disableScroll: true,
		awaitCloseAnimation: true,
		disableFocus: false
	});

	// Cache hacks for tabla & stream pages
	if ($('.tabla-module').length ||
		$('.stream-template-default').length) {

		let current_date = new Date();

		let c_minutes = current_date.getMinutes();
		c_minutes = c_minutes - (c_minutes % 10);

		let c_date = current_date.getFullYear();
		c_date += String(current_date.getMonth());
		c_date += String(current_date.getDate());

		if (window.location.href.search("[?&]c=") == -1) {
			var value = String(c_date + c_minutes);
			window.location.href = (window.location.href.indexOf('?') > -1 ? '&' : '?') + 'c=' + value;
		}
	}


	// expand long blocks with read more
	if (document.querySelector('.js-read-more')) {
		//ReadMore.init();
	}

});
